import { RootState } from '../reducers'

export const getIsLoading = (state: RootState) => state.loginBranding.isLoading
export const getIsConfirmLoading = (state: RootState) => state.loginBranding.isConfirmLoading
export const getIsImageSaving = (state: RootState) => state.loginBranding.isImageSaving
export const getCarouselItems = (state: RootState) => state.loginBranding.items
export const getCarouselItemSelected = (state: RootState) => state.loginBranding.itemSelected
export const getModalVisibility = (name: string) => (state: RootState) =>
  state.loginBranding.modalVisibility[name]?.visible || false
